/* global axios */
import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  list(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`);
  }

  create(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, { template });
  }

  update(inboxId, id, template) {
    return axios.patch(`${this.url}/${inboxId}/whatsapp_templates/${id}`, { template });
  }

  remove(inboxId, { name, hsm_id }) {
    return axios.delete(`${this.url}/${inboxId}/whatsapp_templates`, {
      params: { name, hsm_id },
    });
  }

  sync(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates/sync`);
  }
}

export default new WhatsappTemplatesAPI();
